export default function IconFilter({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path stroke="currentColor" d="M1 5.25h14" />
            <path fill="#fff" stroke="currentColor" d="M3.25 3.75h4v3h-4z" />
            <path stroke="currentColor" d="M1 10.75h14" />
            <path fill="#fff" stroke="currentColor" d="M8.75 9.25h4v3h-4z" />
        </svg>
    )
}
